import * as constants from '../constants';

const mutations = {
  [constants.CORE_TOGGLE_SIDEBAR]: (state, sidebar) => {
    state.sidebar = sidebar;
  },
  [constants.CORE_ADD_NOTIFICATION]: (state, notification) => {
    state.notifications.push(notification);
  },
  [constants.CORE_TOGGLE_NOTIFICATION]: (state, index) => {
    state.notifications.splice(index, 1, {
      ...state.notifications[index],
      visible: !state.notifications[index].visible,
    });
  },
  [constants.CORE_HIDE_NOTIFICATION]: (state, index) => {
    state.notifications.splice(index, 1, {
      ...state.notifications[index],
      visible: false,
    });
  },
  [constants.CORE_BREADCRUMBS_SET]: (state, breadcrumbs) => {
    state.breadcrumbs = breadcrumbs;
  },
  [constants.CORE_BREADCRUMBS_PUSH]: (state, breadcrumb) => {
    state.breadcrumbs.push(breadcrumb);
  },
  [constants.CORE_BREADCRUMBS_POP]: (state) => {
    state.breadcrumbs.pop();
  },
  [constants.CORE_BREADCRUMBS_REPLACE]: (state, payload) => {
    const index = state.breadcrumbs.findIndex((breadcrumb) => breadcrumb.text === payload.find);

    if (index) {
      state.breadcrumbs.splice(index, 1, payload.replace);
    }
  },
  [constants.CORE_BREADCRUMBS_EMPTY]: (state) => {
    state.breadcrumbs = [];
  },
  [constants.CORE_COUNTRIES]: (state, countries) => {
    state.countries = countries;
  },
  [constants.CORE_CONFIG]: (state, config) => {
    state.config = config;
  },
  [constants.CORE_STATE_PROVINCE]: (state, stateProvince) => {
    state.stateProvince = stateProvince;
  },
  [constants.CORE_WAREHOUSES]: (state, warehouses) => {
    state.warehouses = warehouses;
  },
  [constants.CORE_LANGUAGES]: (state, languages) => {
    state.languages = languages;
  },
  [constants.CORE_CURRENCIES]: (state, currencies) => {
    state.currencies = currencies;
  },
  [constants.CORE_STORES]: (state, stores) => {
    state.stores = stores;
  },
  [constants.CORE_STORE]: (state, store) => {
    state.store = store;
  },
  [constants.CORE_IS_LOADING]: (state, isLoading) => {
    state.isLoading = isLoading;
  },
};

export default mutations;
